module.exports = __webpack_public_path__ + "img/John_Julie_Nixon@2x.39c5b418.webp";